import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { UsersService } from '../service/users/users.service';
import { ClientsService } from 'src/app/shared/service/catalogs/clients/clients.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-form-catalog',
  templateUrl: './form-catalog.component.html',
  styleUrls: ['./form-catalog.component.scss'],
})
export class FormCatalogComponent implements OnInit {
  urlBase = environment.urlBase;

  type: string = 'instrumentos';

  titleCard: string = '';

  model = {};

  headers: any;

  token: any;

  service: any;

  isSuperAdminVentas = false;

  editingFolio = false;

  newFolio: number | null = null;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private usersService: UsersService,
    private cookieService: CookieService,
    private http: HttpClient,
    private injector: Injector,
    private clientsService: ClientsService,
    private toastrService: ToastrService,
  ) {
    this.token = this.cookieService.get('token');

    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('X-Requested-With', 'XMLHttpRequest')
      .set('Authorization', 'Bearer ' + this.token);
  }

  ngOnInit(): void {
    this.titleCard = this.data.title;
    this.model = this.data.form;
    this.service = this.injector.get<any>(this.data.action);
    this.isSuperAdminVentas = this.data.isSuperAdminVentas;
  }

  formSubmitted(value: any) {
    this.data.function(value);
  }

  enableFolioEdit(): void {
    this.editingFolio = true;
    this.newFolio = this.data.folio;
  }

  cancelFolioEdit(): void {
    this.editingFolio = false;
    this.newFolio = this.data.folio;
  }

  saveFolio(): void {
    if (this.newFolio === null || this.newFolio === this.data.folio) {
      this.editingFolio = false;

      return;
    }

    this.clientsService
      .updateBranchOfficeFolio(this.data.form.Id.value, this.newFolio)
      .subscribe({
        next: () => {
          this.data.folio = this.newFolio;
          this.editingFolio = false;

          this.toastrService.success('Folio actualizado correctamente');
        },
        error: (err) => {
          this.toastrService.error(
            err.error?.error || 'Error actualizando folio',
          );
        },
      });
  }
}
